import styled from "styled-components";

export const TableCell = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  padding: 0.5em;
  text-align: center;
  border-right: 1px solid #e0e0e0;
  font-size: 16px;
  &:last-of-type: {
    borde: none;
  }
  &.highlighted {
    background: #2196f377;
  }
  font-weight: ${(props) => props.bold && "bold"};
`;
